import BasicResource from '@/api/resource';

class KPIControlResource extends BasicResource {
    constructor () {
        super('analytics-kpis');
    }

    disable (kpiControlId, payload) {
        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/${this.resourceName}/${kpiControlId}/disable`,
            data: payload,
        });
    }

    enable (kpiControlId, payload) {
        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/${this.resourceName}/${kpiControlId}/enable`,
            data: payload,
        });
    }
}

export default new KPIControlResource;
